import { ResponseFormatView } from '@/blocks/Scraper/constants/response-formats';
import { CodeBlockItem } from '@/components/atoms/CodeBlock/CodeBlockItem';
import { useTranslation } from '@/lib/i18n/i18n.client';
import { EmptyRichResponse } from './components/EmptyRichResponse';

export const HTMLResponseView = ({
  viewType,
  data,
}: {
  viewType: ResponseFormatView;
  data: any;
}) => {
  const content: string = data?.results?.[0]?.content;
  const { texts } = useTranslation();

  try {
    if (viewType === 'rich' && content) {
      return (
        <iframe
          className='h-full w-full'
          sandbox='allow-forms allow-scripts'
          srcDoc={content}
        />
      );
    }
    return (
      <CodeBlockItem
        code={content ? content.substring(0, 10_000) + '...truncated' : ''}
        language='HTML'
      />
    );
  } catch (error) {
    return (
      <EmptyRichResponse message={texts.scraper.error.content_not_available} />
    );
  }
};
